<template>
  <el-row>
    <!-- 标签 --> 
    <el-row style="width:70%; margin:0 auto; ">
      <el-menu
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#ffd04b">
        <el-menu-item index="/Index">缴费页</el-menu-item>
        <el-menu-item index="/Exit">退出</el-menu-item>
      </el-menu>
      <div>
        <div class="notice" v-if="false">
          <van-notice-bar left-icon="volume-o" text='当前仅支持浦发银行储蓄卡' />
        </div>
        <div v-show="mainVisible">
          <div style="display: flex;align-items: center;">
            <div v-if="cardList.length === 0" style="text-align:center;padding: 30px 10px;background-color: #fff;border-radius: 5px;width: 100%;">
              <span style="font-size:15px;">暂无银行卡信息，请先新增！</span>
            </div>
            <div v-else>
              <el-card v-for="item in cardList"  :key="item.id" class="box-card" shadow="never">
                <div @click.stop="handleClick('update')">
                  <div style="display: flex;align-items: center;">
                    <div style="background-color: #fff;border-radius: 100px;"><i class="el-icon-bank-card" style="font-size: 22px;padding: 5px;color: #e6a23c;"></i></div>
                    <div style="color: #fff;padding: 5px;">
                      <div style="font-size: 16px;">{{ item.bankNm }}</div>
                      <div>储蓄卡</div>
                    </div>
                  </div>
                  <div>
                    <div style="font-size: 16px;padding: 10px 40px 0 40px;color: #fff;">{{ item.acnm }}</div>
                    <div class="bank-card-number">
                      <span>{{ item.acnoformat }}</span>
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
            <i style="font-size: 50px;padding: 20px;" class="el-icon-circle-plus" @click="handleClick('save')"></i>
          </div>
        </div>
        <div class="my-form" v-show="formVisible">
          <el-form ref="form" :model="form" size="mini" :rules="rules" label-width="130px">
            <el-form-item class="form-item" label="账户名称" prop="acnm" :inline-message="true">
              <el-input v-model="form.acnm" clearable disabled></el-input>
            </el-form-item>
            <el-form-item class="form-item" label="账户号" prop="acno" :inline-message="true">
              <el-input type="number" v-model="form.acno" clearable></el-input>
            </el-form-item>
            <el-form-item class="form-item" label="开户行名称" prop="bankNm" :inline-message="true">
              <el-tooltip
                effect="dark" 
                placement="top-start"
                content="可通过手机银行APP查看账户详情，或致电银行客服获取"
              >
                <el-input v-model="form.bankNm" clearable/>
              </el-tooltip>
            </el-form-item>
            <el-form-item class="form-item" label="开户行联行号" prop="bankNo" :inline-message="true">
              <el-tooltip
                effect="dark" 
                placement="top-start"
                content="一般为12位数字，可拨打对应银行客服电话查询"
              >
                <el-input v-model="form.bankNo" clearable/>
              </el-tooltip>
            </el-form-item>
          </el-form>
          <el-row style="text-align:center;padding:10px 0" >
            <el-button style="width: 45%;" type="info" @click="setVisible('01')">取消</el-button>
            <el-button style="width: 45%;" type="primary" @click="save">确认</el-button>
          </el-row>
        </div>
      </div>
    </el-row>
  </el-row>
</template>
<script>
import vanNoticeBar from 'vant/lib/notice-bar'
import 'vant/lib/notice-bar/style'

export default {
  name: 'Card',
  components: { vanNoticeBar },
  data: function () {
    var validateBankCard = (rule, value, callback) => {
      if (!this.Ginkgo.validateBankCard(value)) {
        callback(new Error('银行卡号格式有误!'))
      } else {
        callback()
      }
    }
    var validateBankNo = (rule, value, callback) => {
      if (!this.Ginkgo.validateBankNo(value)) {
        callback(new Error('开户行联行号格式有误!'))
      } else {
        callback()
      }
    }
    return {
      mainVisible: true,
      formVisible: false,
      cardList: [],
      form: {
        acnm: '',
        acno: '',
        bankNm: '',
        bankNo: ''
      },
      rules: {
        'acnm': [{required: true, message: '请输入账户名称', trigger: 'blur'}],
        'acno': [
          {required: true, message: '请输入账户号', trigger: 'blur'},
          {validator: validateBankCard, trigger: 'blur'}
        ],
        'bankNm': [{required: true, message: '请输入开户行', trigger: 'blur'}],
        'bankNo': [
          {required: true, message: '请输入开户行联行号', trigger: 'blur'},
          {validator: validateBankNo, trigger: 'blur'}

        ]
      }
    }
  },
  mounted: function () {
    if (process.env.NODE_ENV === 'production') {
      var self = this
      // 判断学号信息
      if (this.global.curStudent.studentNo === '') {
        // 提醒没缴费，先去缴费
        self.$confirm('您还未缴费，是否进行缴费!', '提示', {
          confirmButtonText: '确定'
        }).then(() => {
          self.$router.push('/myBillXiFanNew')
          self.route = [{ path: '/myBillXiFanNew', component: require('@/components/XiFan/MyBillXiFanNew'), meta: { title: '新生缴费页面' } }]
          self.$router.addRoutes(self.route)
        }).catch(() => {
          self.$router.go(-1)
          // self.$router.push('/newStudent')
        })
      } else {
        // 查学生银行卡信息
        self.query()
      }
    }
  },
  methods: {
    handleSelect: function (index, indexPath) {
      if (index === '/Exit') {
        this.$router.push('/LoginXiFan')
      }
      if (index === '/Index') {
        this.$router.go(-1)
      }
    },
    query: function () {
      var self = this
      let obj = {}
      obj.studentNo = this.global.curStudent.studentNo
      this.axios.post('/college/getStudentCard', obj)
      .then(function (response) {
        if (response.data.result.success === true) {
          self.cardList = response.data.dataList
          self.cardList.forEach(item => {
            item.acnoformat = self.formatBankCard(item.acno)
          })
        } else {
          self.$alert('银行卡信息查询失败！' + response.data.result.msg)
        }
      }, response => {
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    handleClick: function (val) {
      var self = this
      if (val === 'save') {
        if (this.cardList.length > 0) {
          self.$alert('目前仅支持添加一张银行卡！')
        } else {
          self.setVisible('02')
        }
      } else {
        if (this.cardList.length > 0 && this.cardList[0].isEdit === '00') {
          let obj = self.Ginkgo.cloneObj(this.cardList[0])
          self.$refs['form'].resetFields()
          self.form.acnm = obj.acnm
          self.form.acno = obj.acno
          self.form.bankNm = obj.bankNm
          self.form.bankNo = obj.bankNo
          self.setVisible('02')
        } else {
          self.$alert('当前银行卡信息不支持修改！')
        }
      }
    },
    save: function () {
      var self = this
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.studentName = this.global.curStudent.studentName
          this.form.studentNo = this.global.curStudent.studentNo
          this.form.uid = this.global.curStudent.uid
          this.form.dataDt = this.Ginkgo.getTimeStamp(new Date())
          this.form.statusCode = '00'
          this.form.isEdit = '00'
          this.axios.post('/college/saveStudentCard', this.form)
          .then(function (response) {
            if (response.data.result.success === true) {
              self.query()
              self.setVisible('01')
              self.$message({ type: 'success', message: '银行卡信息维护成功!' })
            } else {
              self.$alert('银行卡信息维护失败！' + response.data.result.msg)
            }
          }, response => {
          })
          .catch(function (error) {
            console.log(error)
          })
        }
      })
    },
    setVisible: function (showType) {
      if (showType === '01') {
        // 银行卡展示页面
        this.mainVisible = true
        this.formVisible = false
      } else if (showType === '02') {
        // 表单页面
        this.mainVisible = false
        if (!this.form.acnm || this.form.acnm === '') {
          this.form.acnm = this.global.curStudent.studentName
        }
        this.formVisible = true
      }
    },
    formatBankCard: function(cardNo) {
      // 先去除所有非数字字符，避免干扰
      const pureCard = cardNo.replace(/\D/g, '')
      // 每4位加空格，最后去除末尾空格
      return pureCard.replace(/(\d{4})(?=\d)/g, '$1 ').trim()
    }
  }
}
</script>
<style scoped>
.el-card {
  background: linear-gradient(to right, #2e4d8f, #4392e3) !important;
  border-radius: 10px !important;
  width: 350px;
  margin: 20px 0;
}
.box-card /deep/ .el-card__body {
  font-size: 14px;
  background: linear-gradient(to right, #2e4d8f, #4392e3) !important;
  padding: 20px !important;
}
.bank-card-number {
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 40px;
}
.my-form {
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}
.form-item {
  padding: 10px 0;
}
</style>


// WEBPACK FOOTER //
// card.vue?3084004d